import { incrementGetFileProviderItemsRequestCount } from './helpers/getFileProviderItemsRequestCount';
import loadMoreItemsForSelectedProvider from './loadMoreItemsForSelectedProvider';
import { getFilePickerStore } from '../store/filePickerStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import { action } from 'satcheljs/lib/legacy';

export default action('refreshFileProviderItems')(function refreshFileProviderItems() {
    if (isFeatureEnabled('doc-filepicker-preload')) {
        incrementGetFileProviderItemsRequestCount();
        loadMoreItemsForSelectedProvider(getFilePickerStore().viewState, true);
    }
});
